const MINUTES = 5
const SECONDS_IN_MINUTE = 60
const MS_IN_SECOND = 1000

export const REOPEN_INTERVAL_IN_MS = MINUTES * SECONDS_IN_MINUTE * MS_IN_SECOND
